import OnboardingModal from './onboardingModal'

export { OnboardingModal }
